export default __webpack_public_path__ + "static/media/search-page.b4d8880c.jpg";